import { apiFetch } from './api';
import { Plan } from '../types';

export interface CreatePlanRQ {
  name: string;
  description?: string;
  price: number;
  initialCredits: number;
  duration: 'month' | 'year' | 'free';
}

export type UpdatePlanRQ = CreatePlanRQ;

export async function getPlans(): Promise<Plan[]> {
  return apiFetch<Plan[]>(`/Plan/GetAll`, { auth: true });
}

export async function getPlanById(id: string): Promise<Plan> {
  return apiFetch<Plan>(`/Plan/Get/${encodeURIComponent(id)}`, { auth: true });
}

export async function createPlan(data: CreatePlanRQ): Promise<Plan> {
  return apiFetch<Plan>(`/Plan/Create`, {
    method: 'POST',
    auth: true,
    body: JSON.stringify(data),
  });
}

export async function updatePlan(id: string, data: UpdatePlanRQ): Promise<Plan> {
  return apiFetch<Plan>(`/Plan/Update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });
}

export async function deletePlan(id: string): Promise<void> {
  return apiFetch<void>(`/Plan/Delete/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    auth: true,
  });
}

export async function getPlansByDuration(duration: string): Promise<Plan[]> {
  return apiFetch<Plan[]>(`/Plan/GetByDuration/${encodeURIComponent(duration)}`, { auth: true });
}

export async function searchPlans(query: string): Promise<Plan[]> {
  return apiFetch<Plan[]>(`/Plan/search?q=${encodeURIComponent(query)}`, { auth: true });
}


